import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../api/auth';
import Loader from '../components/Loader';
import useUserStore from '../store/useUserStore';
var CryptoJS = require("crypto-js");

export default function Login() {

    const { setUser } = useUserStore();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // ✅ must be inside the component
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });

    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // Clear error for the field being typed
        if (errors[name]) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: '',
            }));
        }

    };

    const validate = () => {
        const newErrors = {};
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.password) newErrors.password = 'Password is required';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!validate()) return;

        try {
            setLoading(true);

            let encryptedPassword = CryptoJS.AES.encrypt(formData.password, process.env.REACT_APP_CRYPTO_SECRET).toString();
            const encryptedFormData = {
                ...formData,
                password: encryptedPassword,
            };

            const response = await loginUser(encryptedFormData);

            if (response.status === 200) {
                setUser({
                    "name": response.data.user.name,
                    "email": response.data.user.email,
                    "isLoggedIn": true,
                    "token": response.data.token,
                    "role": response.data.user.role,
                })
                navigate('/dashboard');
            } else {

            }
        } catch (error) {

            const message = error?.data?.error || error?.statusText || 'Login failed';
            setApiError(message);
            setTimeout(() => {
                setApiError(null);
            }, 5000);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}
            <div className="container-scroller">
                <div className="container-fluid page-body-wrapper full-page-wrapper">


                    <div className="row w-100">
                        <div className="content-wrapper full-page-wrapper d-flex align-items-center auth login-bg">
                            <div className="card col-lg-4 mx-auto">
                                <div className="card-body px-5 py-5">
                                    {apiError && <h4 className="card-title" style={{ textAlign: "center", color: "red" }}>{apiError}</h4>}
                                    {/* <h4 className="card-title" style={{ textAlign: "center", color: "red" }}>Basic form elements</h4> */}
                                    <h3 className="card-title text-start mb-3" style={{ textAlign: "center" }}>Login</h3>
                                    <form onSubmit={handleLogin}>
                                        <div className="form-group">
                                            <label>Username or email *</label>
                                            <input
                                                type="text"
                                                className="form-control p_input"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                            />
                                            {errors.email && <span className="text-danger">{errors.email}</span>}
                                        </div>

                                        <div className="form-group">
                                            <label>Password *</label>
                                            <input
                                                type="password"
                                                className="form-control p_input"
                                                name="password"
                                                value={formData.password}
                                                onChange={handleChange}
                                            />
                                            {errors.password && <span className="text-danger">{errors.password}</span>}
                                        </div>

                                        <div className="text-center d-grid gap-2">
                                            <button type="submit" className="btn btn-primary btn-block enter-btn">Login</button>
                                        </div>

                                        {/* <p className="sign-up">Don't have an Account?<a href="#"> Sign Up</a></p> */}
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
